import { useEffect } from "react"
import { isIOS } from "~/common/platform"

/**
 * Workaround for an iOS Safari bug where layout is not recalculated after the
 * virtual keyboard is dismissed. When a focused input causes content to scroll
 * out of the viewport, hiding the keyboard leaves the page stuck in the scrolled
 * state. Forcing a scroll on `focusout` triggers a layout recalculation and
 * restores the viewport to the correct position.
 */
export const useForceLayoutOnBlur = (): void => {
  useEffect(() => {
    if (!isIOS()) {
      return
    }

    const forceRecalculateLayout = (): void => {
      window.scrollTo(0, window.scrollY)
    }
    window.addEventListener("focusout", forceRecalculateLayout)

    return () => {
      window.removeEventListener("focusout", forceRecalculateLayout)
    }
  }, [])
}
